export const ACTION_RESET = 'FETCH_SBESPEAKER_RESET';
export const ACTION_REQUEST = 'FETCH_SBESPEAKER_REQUEST';
export const ACTION_SUCCESS = 'FETCH_SBESPEAKER_SUCCESS';
export const ACTION_ERROR = 'FETCH_SBESPEAKER_ERROR';
